<template>
  <v-card>
    <v-card-title>
      <h2 class="card-title">{{ $t('base.create_period') }}</h2>
    </v-card-title>

    <v-card-content>
      <v-text-field  
      :focus="true"
       class="mb-3"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        :label="$t('base.name')"
         v-model="form.name"
         autofocus />
         <!-- <v-time-field
         :label="$t('base.period') + ' ' + $t('base.from')"
         v-model="form.loading_time_from"
         class="mb-3"
         /> -->
         <v-time-field
         :from="form.loading_time_from"
         :to="form.loading_time_to"
         @updateTime="updateTimeHandler"
         class="mb-3"
         />
    </v-card-content>

    <v-card-actions>
      <v-btn class="mr-2" :loading="loading" @click="onCreate">
        {{ $t('base.add') }}
      </v-btn>

    </v-card-actions>
  </v-card>
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'CreatePeriodModal',
  mixins: [formErrorsMixin],
  components: {
  },

  data () {
    return {
      form: {
        name: '',
        loading_time_from: '06:00:00',
        loading_time_to: '11:00:00',
      },
      errors: {
        name: null
      },
      loading: false
    }
  },

  methods: {
    async onCreate () {
      if (!this.validateData()) return

      const payload = {
        farm: this.$route.params.farm_id,
        ...this.form
      }

      this.loading = true
      const { errors } = await api.loadings.create(payload)
      if (!errors) {
        this.$emit('update')
        this.$emit('close')
        this.$toasted.show(this.$t('Created'))
      } else {
        this.errors = errors
        this.loading = false

        if (errors[0].name === '5') {
          this.errors.name = ['5']
        }
      }
      this.loading = false
    },
    validateData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = this.errors.name = ['3']
        return false
      } else if (this.form.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
        return false
      }

      if (!this.form.loading_time_from) {
        this.$toasted.show('loading_time_from')
        return false
      }
      if (!this.form.loading_time_to) {
        this.$toasted.show('loading_time_to')
        return false
      }
      return true
    },
    updateTimeHandler (startTime, endTime) {
      this.form.loading_time_from = startTime
      this.form.loading_time_to = endTime
    }
  },
}
</script>